import { Link } from 'react-router-dom';
import { useState } from 'react';

function Footer() {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // Cities list for Cities We Serve section
  const cities = [
    { name: "New York City", route: "/new-york-city", state: "NY" },
    { name: "Connecticut", route: "/connecticut", state: "CT" },
    { name: "New Jersey", route: "/new-jersey", state: "NJ" },
    { name: "Pennsylvania", route: "/pennsylvania", state: "PA" },
    { name: "Washington", route: "/washington-dc", state: "D.C" },
    { name: "Rhode Island", route: "/rhode-island", state: "RI" }
  ];

  return (
    <footer className="bg-black text-white py-8 px-4 sm:px-6 lg:px-10">
      {/* Desktop Footer */}
      <div className="hidden lg:block max-w-[1200px] mx-auto">
        {/* Main Footer Columns */}
        <div className="grid grid-cols-4 gap-8">
          {/* Column 1 - Logo & Contact */}
          <div className="space-y-2.5">
            {/* Logo */}
            <img 
              src="/mvu.png" 
              alt="Majestic Voyage USA"
              className="h-14 mb-4"
            />
            
            {/* Contact Section */}
            <div className="mb-6">
              <h3 className="text-white font-bold mb-4 text-base">Contact Us</h3>
              <div className="space-y-3 text-sm">
                {/* Address */}
                <div className="flex items-start">
                  <div className="mr-3 mt-0.5 flex-shrink-0">
                    <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z" />
                    </svg>
                  </div>
                  <span className="text-gray-300">169 Munro Boulevard Valley Stream NY 11581</span>
                </div>
                
                {/* Phone Numbers */}
                <div className="space-y-1">
                  <div className="flex items-center">
                    <div className="mr-3 flex-shrink-0">
                      <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20 15.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.3-1.1-.5-2.3-.5-3.5 0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1 0 9.4 7.6 17 17 17 .6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1z" />
                      </svg>
                    </div>
                    <a href="tel:+17182004140" className="text-gray-300 hover:text-logo-green transition-colors">
                      +1 (718) 200 4140
                    </a>
                  </div>
                  <div className="flex items-center">
                    <div className="mr-3 flex-shrink-0">
                      <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20 15.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.3-1.1-.5-2.3-.5-3.5 0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1 0 9.4 7.6 17 17 17 .6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1z" />
                      </svg>
                    </div>
                    <a href="tel:+12124332303" className="text-gray-300 hover:text-logo-green transition-colors">
                      +1 (212) 433 2303
                    </a>
                  </div>
                </div>
                
                {/* Email */}
                <div className="flex items-center">
                  <div className="mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                  </div>
                  <a href="mailto:info@majesticvoyageusa.com" className="text-gray-300 hover:text-logo-green transition-colors">
                    info@majesticvoyageusa.com
                  </a>
                </div>
                
                {/* Service Hours */}
                <div className="flex items-center">
                  <div className="mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                    </svg>
                  </div>
                  <span className="text-gray-300">24/7 Service - 365 Days a Year</span>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-5 text-base">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/booknow" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/fleet" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Our Fleet
                </Link>
              </li>
              <li>
                <Link to="/cities" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Cities We Serve
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-white font-bold mb-5 text-base">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/airport-transfer-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Airport Transfers
                </Link>
              </li>
              <li>
                <Link to="/hourly-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Hourly Service
                </Link>
              </li>
              <li>
                <Link to="/corporate-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Corporate Service
                </Link>
              </li>
              <li>
                <Link to="/wedding-limousine-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Wedding Transportation
                </Link>
              </li>
              <li>
                <Link to="/cruise-transfer-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Cruise Transfer
                </Link>
              </li>
              <li>
                <Link to="/concerts-events-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center">
                  <span className="text-white mr-1.5">›</span>
                  Concerts & Events
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Cities We Serve */}
          <div>
            <h3 className="text-white font-bold mb-5 text-base">Cities We Serve</h3>
            <ul className="space-y-2">
              {cities.map((city, index) => (
                <li key={index}>
                  <Link 
                    to={city.route} 
                    className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center"
                  >
                    <span className="text-white mr-1.5">›</span>
                    {city.name}{city.state ? `, ${city.state}` : ''}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom Copyright Bar */}
        <div className="border-t border-gray-800 pt-6 mt-8">
          <div className="max-w-[1000px] mx-auto">
            <div className="flex flex-col items-center justify-center text-center space-y-4">
              <div className="text-gray-400 text-sm">
                Copyright © 2025 All rights reserved | Website Design & Developed by{' '}
                <a href="https://awktechz.com/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-logo-green transition">
                  AWKT
                </a>
              </div>
              {/* Social Media Icons */}
              <div className="flex items-center gap-6">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-logo-green transition-colors"
                  aria-label="Facebook"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-logo-green transition-colors"
                  aria-label="Twitter"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                  </svg>
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-logo-green transition-colors"
                  aria-label="Instagram"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-logo-green transition-colors"
                  aria-label="LinkedIn"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Footer - Accordion */}
      <div className="lg:hidden max-w-[1200px] mx-auto">
        {/* Mobile Accordion Footer */}
        <div className="block lg:hidden">
          {/* Company Logo, Contact & Cities We Serve */}
          <div className="mb-6 pb-6 border-b border-gray-800 text-center">
            <img 
              src="/mvu.png" 
              alt="Majestic Voyage USA"
              className="h-14 mb-4 mx-auto"
            />
            
            {/* Contact Section */}
            <div className="mb-6">
              <h3 className="text-white font-bold mb-4 text-base">Contact Us</h3>
              <div className="space-y-3 text-sm">
                {/* Address */}
                <div className="flex items-start justify-center">
                  <div className="mr-3 mt-0.5 flex-shrink-0">
                    <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z" />
                    </svg>
                  </div>
                  <span className="text-gray-300 text-sm">169 munro blvd valley stream ny 11581</span>
                </div>
                
                {/* Phone Numbers */}
                <div className="flex items-start justify-center">
                  <div className="mr-3 mt-0.5 flex-shrink-0">
                    <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 15.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.3-1.1-.5-2.3-.5-3.5 0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1 0 9.4 7.6 17 17 17 .6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1z" />
                    </svg>
                  </div>
                  <div className="space-y-1">
                    <a href="tel:+17182004140" className="text-gray-300 hover:text-logo-green transition-colors text-sm block">
                      +1 (718) 200 4140
                    </a>
                    <a href="tel:+12124332303" className="text-gray-300 hover:text-logo-green transition-colors text-sm block">
                      +1 (212) 433 2303
                    </a>
                  </div>
                </div>
                
                {/* Email */}
                <div className="flex items-start justify-center">
                  <div className="mr-3 mt-0.5 flex-shrink-0">
                    <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                  </div>
                  <a href="mailto:info@majesticvoyageusa.com" className="text-gray-300 hover:text-logo-green transition-colors text-sm">
                    info@majesticvoyageusa.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links Accordion */}
          <div className="border-b border-gray-800">
            <button
              onClick={() => toggleSection('quickLinks')}
              className="w-full flex justify-between items-center py-4 text-left"
            >
              <h3 className="text-white font-bold text-base">Quick Links</h3>
              <svg 
                className={`w-5 h-5 text-white transition-transform duration-300 ${
                  openSection === 'quickLinks' ? 'rotate-180' : ''
                }`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSection === 'quickLinks' && (
              <div className="pb-4 space-y-2">
                <Link to="/" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Home
                </Link>
                <Link to="/booknow" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Book Now
                </Link>
                <Link to="/about" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  About
                </Link>
                <Link to="/services" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Our Services
                </Link>
                <Link to="/fleet" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Our Fleet
                </Link>
                <Link to="/cities" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Cities We Serve
                </Link>
                <Link to="/contact" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Contact Us
                </Link>
              </div>
            )}
          </div>

          {/* Services Accordion */}
          <div className="border-b border-gray-800">
            <button
              onClick={() => toggleSection('services')}
              className="w-full flex justify-between items-center py-4 text-left"
            >
              <h3 className="text-white font-bold text-base">Services</h3>
              <svg 
                className={`w-5 h-5 text-white transition-transform duration-300 ${
                  openSection === 'services' ? 'rotate-180' : ''
                }`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSection === 'services' && (
              <div className="pb-4 space-y-2">
                <Link to="/airport-transfer-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Airport Limo Service in NYC
                </Link>
                <Link to="/concerts-events-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Event & Party Transportation
                </Link>
                <Link to="/wedding-limousine-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Marriage Limo Service
                </Link>
                <Link to="/corporate-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Corporate Limo Service
                </Link>
                <Link to="/city-transfer" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  NYC City tenures
                </Link>
                <Link to="/hourly-limo-service" className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5">
                  <span className="text-white mr-1.5">›</span>
                  Hourly Limo Settlements
                </Link>
              </div>
            )}
          </div>

          {/* Cities We Serve Accordion */}
          <div className="border-b border-gray-800">
            <button
              onClick={() => toggleSection('cities')}
              className="w-full flex justify-between items-center py-4 text-left"
            >
              <h3 className="text-white font-bold text-base">Cities We Serve</h3>
              <svg 
                className={`w-5 h-5 text-white transition-transform duration-300 ${
                  openSection === 'cities' ? 'rotate-180' : ''
                }`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSection === 'cities' && (
              <div className="pb-4 space-y-2">
                {cities.map((city, index) => (
                  <Link 
                    key={index}
                    to={city.route} 
                    className="text-gray-300 hover:text-logo-green transition-colors duration-200 text-sm flex items-center py-1.5"
                  >
                    <span className="text-white mr-1.5">›</span>
                    {city.name}{city.state ? `, ${city.state}` : ''}
                  </Link>
                ))}
              </div>
            )}
          </div>
           
          {/* Bottom Copyright Bar for Mobile */}
          <div className="pt-6 mt-4">
            <div className="max-w-[1000px] mx-auto">
              <div className="flex flex-col items-center justify-center text-center space-y-4">
                <div className="text-gray-400 text-sm">
                  Copyright © 2026 All rights reserved | Website Design & Developed by{' '}
                  <a href="https://awktechz.com/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-logo-green transition">
                    AWKT
                  </a>
                </div>
                {/* Social Media Icons */}
                <div className="flex items-center gap-6">
                  <a 
                    href="https://facebook.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-logo-green transition-colors"
                    aria-label="Facebook"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                  <a 
                    href="https://twitter.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-logo-green transition-colors"
                    aria-label="Twitter"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                    </svg>
                  </a>
                  <a 
                    href="https://instagram.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-logo-green transition-colors"
                    aria-label="Instagram"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                  <a 
                    href="https://linkedin.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-logo-green transition-colors"
                    aria-label="LinkedIn"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;


